// 过滤格式，将格式生成成符合集联选择器的格式
export function generatePairs(original = [], options = []) {
  const result = [];

  original.forEach((grandpa) => {
    options.forEach((parent) => {
      const found = parent.children?.find((child) => child.value === grandpa)
      if (found) {
        result.push([parent.value, found.value]);
      }
    })
  })

  return result;
}

// 还原入参格式
export function restoreOriginalObject(pairs) {
  const originalObject = {
    // category_value: [],
    industry: []
  };

  pairs.forEach((pair) => {
    const [region, location] = pair;

    // if (!originalObject.category_value.includes(region)) {
    //   originalObject.category_value.push(region);
    // }

    originalObject.industry.push(location);
  });

  return originalObject.industry;
}